import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { AccountUsersState } from './account-users.state';
import { AccountUsersStore } from './account-users.store';

@Injectable({ providedIn: 'root' })
export class AccountUsersQuery extends QueryEntity<AccountUsersState> {
  constructor(protected readonly store: AccountUsersStore) {
    super(store);
  }
}
